import { render, staticRenderFns } from "./proFog.vue?vue&type=template&id=65f61cc3&scoped=true&"
import script from "./proFog.vue?vue&type=script&lang=js&"
export * from "./proFog.vue?vue&type=script&lang=js&"
import style0 from "./proFog.vue?vue&type=style&index=0&id=65f61cc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f61cc3",
  null
  
)

export default component.exports